import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import { ValueType } from '../../app/types';

interface ValueTypeInputProps {
  value: ValueType;
  onChange?: (v: ValueType) => void;
};

type ChangeEvent = (e: React.ChangeEvent<HTMLSelectElement>) => void;

function ValueTypeInput(props: ValueTypeInputProps) {
  const { value, onChange } = props;

  const onTypeChanged: ChangeEvent = e => {
    if (onChange) {
      onChange(parseInt(e.target.value));
    }
  };

  const renderHelpText = (value: ValueType) => {
    switch (value) {
      case ValueType.Integer:
        return (<small className="form-text text-muted">Values are input as integer numbers without decimal places. Example: 4.</small>);
      case ValueType.Float:
        return (<small className="form-text text-muted">Values are input as numbers containing decimal places. Example: 4.321.</small>);
      case ValueType.Boolean:
        return (<small className="form-text text-muted">Values are input as true/false values.</small>);
    }
    return;
  }

  return (
    <>
      <Row>
        <Col md={4}>
          <Form.Select value={value} onChange={onTypeChanged}>
            <option value={ValueType.Integer}>Number</option>
            <option value={ValueType.Float}>Decimal</option>
            <option value={ValueType.Boolean}>Checkbox</option>
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col>
          {renderHelpText(value)}
        </Col>
      </Row>
    </>)
}

export default ValueTypeInput;